import { combineReducers } from "redux";
import authReducer from "./authReducer";
import vehicleReducer from "./vehicleReducer";
import filterReducer from "./filterCollapseReducer";
import sideMenuReducer from "./sideMenuReducer";
import searchReducer from "./searchReducer";
import cartReducer from "./cartManagementReducer";

const rootReducer = combineReducers({
  authReducer,
  vehicleReducer,
  filterReducer,
  sideMenuReducer,
  searchReducer,
  cartReducer
});

export default rootReducer;
